module.exports = __webpack_public_path__ + "img/1515214708.c2bbe0db.jpg";